import {
    CLEAR_ATTACHED_FILES_AND_FOLDERS,
    FETCH_ATTACHED_FILE_FULFILLED,
    FETCH_ATTACHED_FILE_PENDING,
    FETCH_ATTACHED_FILE_REJECTED,
    FETCH_ATTACHED_FOLDER_FULFILLED,
    FETCH_ATTACHED_FOLDER_PENDING,
    FETCH_ATTACHED_FOLDER_REJECTED,
    REMOVE_ATTACHED_FILE,
    REMOVE_ATTACHED_FOLDER
} from "./page-action-types";

export interface IPageState {
    attachedFiles: any[];
    attachedFolders: any[]; // List of folders containing lists of files.
}

const initialState: IPageState = {
    attachedFiles: [],
    attachedFolders: []
}

export const pageReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ATTACHED_FILE_PENDING:
            return {
                ...state,
                attachedFiles: [...state.attachedFiles, { id: action.meta.id, isLoading: true }]
            };

        case FETCH_ATTACHED_FILE_REJECTED:
            return {
                ...state,
                attachedFiles: state.attachedFiles.map((file) => file.id == action.meta.id
                    ? { ...file, isLoading: false, isError: true }
                    : file,
                ),
            };

        case FETCH_ATTACHED_FILE_FULFILLED:
            return {
                ...state,
                attachedFiles: state.attachedFiles.map((file) => file.id == action.meta.id
                    ? { ...file, ...action.payload.data, isLoading: false }
                    : file,
                ),
            };

        case FETCH_ATTACHED_FOLDER_PENDING:
            return {
                ...state,
                attachedFolders: [...state.attachedFolders, { id: action.meta.folder.id, isLoading: true }]
            };

        case FETCH_ATTACHED_FOLDER_REJECTED:
            return {
                ...state,
                attachedFolders: state.attachedFolders.map((folder) => folder.id == action.meta.folder.id
                    ? { ...folder, isLoading: false, isError: true }
                    : folder,
                ),
            };

        case FETCH_ATTACHED_FOLDER_FULFILLED:
            return {
                ...state,
                attachedFolders: state.attachedFolders.map((folder) => folder.id == action.meta.folder.id
                    ? {...folder, isDirectory: true, isLoading: false, ...action.payload.data, }
                    : folder,
                ),
            };

        case CLEAR_ATTACHED_FILES_AND_FOLDERS:
            return {
                ...state,
                attachedFiles: [],
                attachedFolders: [],
            };

        case REMOVE_ATTACHED_FILE:
            return {
                ...state,
                attachedFiles: state.attachedFiles.filter(f => f.id !== action.meta.id),
            };

        case REMOVE_ATTACHED_FOLDER:
            return {
                ...state,
                attachedFolders: state.attachedFolders.filter(f => f.id !== action.meta.id),
            };

        default:
            return state
    }
};
